<template>
  <aside
    class="
      hidden
      xl:order-first xl:flex xl:flex-col
      flex-shrink-0
      w-96
      border-r border-gray-200
    "
  >
    <div class="px-6 pt-6 pb-4">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-lg font-medium text-gray-900">
            {{ t("directory") }}
          </h2>
          <p
            class="mt-1 text-sm text-gray-600"
            v-show="!$page.props.filters.search"
          >
            {{ t("directory_subtitle", { number: totalCustomers }) }}
          </p>
          <p
            class="mt-1 text-sm text-gray-600"
            v-show="$page.props.filters.search"
          >
            {{
              t("directory_subtitle_search", {
                hits: customers.length,
                number: totalCustomers,
              })
            }}
          </p>
        </div>
        <Link
          :data="{ search: $page.props.filters.search }"
          :href="route('customers.create')"
        >
          <PlusCircleIcon class="w-8 h-8 hover:text-green-400 text-green-500" />
        </Link>
      </div>
      <form class="mt-6 flex space-x-4" action="#">
        <div class="flex-1 min-w-0">
          <label for="search" class="sr-only">Search</label>
          <div class="relative rounded-md shadow-sm">
            <div
              class="
                absolute
                inset-y-0
                left-0
                pl-3
                flex
                items-center
                pointer-events-none
              "
            >
              <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <input
              type="search"
              name="search"
              id="search"
              class="
                focus:ring-pink-500 focus:border-pink-500
                block
                w-full
                pl-10
                sm:text-sm
                border-gray-300
                rounded-md
              "
              placeholder="Search"
            />
          </div>
        </div>
        <button
          type="submit"
          class="
            inline-flex
            justify-center
            px-3.5
            py-2
            border border-gray-300
            shadow-sm
            text-sm
            font-medium
            rounded-md
            text-gray-700
            bg-white
            hover:bg-gray-50
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-pink-500
          "
        >
          <FilterIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          <span class="sr-only">Search</span>
        </button>
      </form>
    </div>
    <!-- Directory list -->
    <nav class="flex-1 min-h-0 overflow-y-auto" aria-label="Directory">
      <div
        v-for="letter in Object.keys(directory)"
        :key="letter"
        class="relative"
      >
        <div
          class="
            z-10
            sticky
            top-0
            border-t border-b border-gray-200
            bg-gray-50
            px-6
            py-1
            text-sm
            font-medium
            text-gray-500
          "
        >
          <h3>{{ letter }}</h3>
        </div>
        <ul role="list" class="relative z-0 divide-y divide-gray-200">
          <li v-for="person in directory[letter]" :key="person.id">
            <div
              class="
                relative
                px-6
                py-5
                flex
                items-center
                space-x-3
                hover:bg-gray-50
                focus-within:ring-2
                focus-within:ring-inset
                focus-within:ring-pink-500
              "
            >
              <div class="flex-shrink-0">
                <img
                  class="h-10 w-10 rounded-full"
                  :src="person.imageUrl"
                  alt=""
                />
              </div>
              <div class="flex-1 min-w-0">
                <a href="#" class="focus:outline-none">
                  <!-- Extend touch target to entire panel -->
                  <span class="absolute inset-0" aria-hidden="true" />
                  <p class="text-sm font-medium text-gray-900">
                    {{ person.name }}
                  </p>
                  <p class="text-sm text-gray-500 truncate">
                    {{ person.role }}
                  </p>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </aside>

  <aside
    class="
      flex
      order-first
      flex-col flex-shrink-0
      w-full
      xl:w-96
      border-r border-gray-200
    "
  >
    <div class="px-6 pt-6 pb-4">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-lg font-medium text-gray-900">
            {{ t("directory") }}
          </h2>
          <p
            class="mt-1 text-sm text-gray-600"
            v-show="!$page.props.filters.search"
          >
            {{ t("directory_subtitle", { number: totalCustomers }) }}
          </p>
          <p
            class="mt-1 text-sm text-gray-600"
            v-show="$page.props.filters.search"
          >
            {{
              t("directory_subtitle_search", {
                hits: customers.length,
                number: totalCustomers,
              })
            }}
          </p>
        </div>
        <Link
          :data="{ search: $page.props.filters.search }"
          :href="route('customers.create')"
        >
          <PlusCircleIcon class="w-8 h-8 hover:text-green-400 text-green-500" />
        </Link>
      </div>
      <form class="mt-6 flex space-x-4" @submit.prevent="searchCustomers">
        <div class="flex-1 min-w-0">
          <ui-input
            v-model="form.search"
            placeholder="Search"
            type="text"
            inputStyling="pl-10"
          >
            <template #leadingContent>
              <div
                class="
                  absolute
                  inset-y-0
                  left-0
                  pl-3
                  flex
                  items-center
                  pointer-events-none
                "
              >
                <SearchIcon class="h-5 w-5 text-gray-400" />
              </div>
            </template>
          </ui-input>
        </div>
        <ui-button
          backgroundStyling="bg-white"
          borderStyling="border border-gray-300"
          textColorStyling="text-gray-700 hover:text-gray-500"
          type="submit"
        >
          <FilterIcon class="h-5 w-5 text-gray-400" />
        </ui-button>
      </form>
    </div>
    <!-- Directory list -->
    <nav
      class="flex-1 min-h-0 relative overflow-y-auto"
      scroll-region
      aria-label="Directory"
    >
      <div v-for="(letterCustomers, letter) in sortedCustomers" :key="letter">
        <div
          class="
            z-10
            sticky
            top-0
            border-t border-b border-gray-200
            bg-gray-50
            px-6
            py-1
            text-sm
            font-medium
            text-gray-500
          "
        >
          <h3 class="uppercase">{{ letter }}</h3>
        </div>
        <ul class="relative z-0 divide-y divide-gray-200">
          <li
            v-for="letterCustomer in letterCustomers"
            :key="letterCustomer.id"
          >
            <div
              class="
                relative
                px-6
                py-5
                flex
                items-center
                space-x-3
                hover:bg-gray-50
                focus-within:ring-2
                focus-within:ring-inset
                focus-within:ring-light-blue-500
              "
            >
              <div class="flex-shrink-0">
                <ui-avatar
                  backgroundStyling="bg-light-blue-200"
                  textStyling="text-white"
                  sizeStyling="h-10 w-10"
                />
              </div>
              <div class="flex-1 min-w-0">
                <Link
                  :data="{ search: $page.props.filters.search }"
                  preserve-scroll
                  preserve-state
                  :href="
                    route('customers.edit', { customer: letterCustomer.id })
                  "
                  class="focus:outline-none"
                >
                  <!-- Extend touch target to entire panel -->
                  <span class="absolute inset-0" aria-hidden="true"></span>
                  <p class="text-sm font-medium text-gray-900">
                    {{ letterCustomer.name }}
                  </p>
                  <p class="text-sm text-gray-500 truncate">
                    {{ letterCustomer.fiscal_name }}
                  </p>
                </Link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </aside>
</template>

<script>
import { PlusCircleIcon, FilterIcon } from "@heroicons/vue/solid";
import { SearchIcon } from "@heroicons/vue/outline";
import { useI18n } from "vue-i18n";

export default {
  components: {
    PlusCircleIcon,
    SearchIcon,
    FilterIcon,
  },

  props: {
    customers: { type: Object, required: true },

    totalCustomers: { type: Number, required: true },

    sortedCustomers: { type: Object, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      form: {
        search: this.$page.props.filters.search,
      },
    };
  },

  methods: {
    searchCustomers() {
      this.$inertia.visit(this.route("customers.index"), {
        data: {
          search: this.form.search,
        },
      });
    },
  },
};
</script>

<i18n>
{
  "es": {
    "directory": "Directorio de clientes",
    "directory_subtitle": "Buscar directorio de {number} clientes",
    "directory_subtitle_search": "{hits} resultado(s) en la busqueda de {number} cliente(s)"
  }
}
</i18n>